module.exports = __webpack_public_path__ + "static/media/ibBTC.19319ddd.svg";